export default "__VITE_ASSET__CIom0wJy__"